module.exports = __webpack_public_path__ + "img/15.c7634d70.jpg";